//#region Libraries
import { Column } from "components/styles";
import styled from "styled-components";
//#endregion

export const Container = styled(Column)`
    width: 350px;
    padding: 0 10px;
    padding-bottom: 5px;
`;
export const ActionButtons = styled(Column).attrs({
	as: "footer",
	gap: "12px"
})``;